const pathBase = `/system/public_statistics/`;

export const publicStatistics = {
  get: () => pathBase,
};
